import { render } from "./bottom.vue?vue&type=template&id=1f15f4b9&scoped=true"
import script from "./bottom.vue?vue&type=script&lang=js"
export * from "./bottom.vue?vue&type=script&lang=js"

import "./bottom.vue?vue&type=style&index=0&id=1f15f4b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f15f4b9"]])

export default __exports__